import React from "react";
import PropTypes from "prop-types";
import Spinner from "../../components/spinner";
import styled from "styled-components";
import { Translation } from "../../core/translate";

const RecaptchaContainer = styled.div`
  position: relative;
`;

class Recaptcha extends React.Component {
  constructor() {
    super();
    this.state = { loading: true };
  }

  componentDidMount() {
    this.loadRecaptchaScript();
  }

  recaptchaLoaded = () => {
    const renderRecaptcha = (sitekey, stoken) => {
      window.grecaptcha.render("g-recaptcha", {
        sitekey: sitekey,
        stoken: stoken
      });
      if (this.props.onLoad) {
        this.props.onLoad();
      }
      this.setState({ loading: false });
    };
    const { captchaKey, captchaToken } = this.props;
    if (captchaKey && captchaToken) {
      renderRecaptcha(captchaKey, captchaToken);
    } else {
      Jigsaw.User.generateCaptcha(response => {
        const { captcha_key, captcha_token } = response.data;
        renderRecaptcha(captcha_key, captcha_token);
      });
    }
  };

  recaptchaExpired = () => {
    this.setState({ loading: true });
    var old = document.getElementById("g-recaptcha");
    old.parentNode.insertBefore(old.cloneNode(), old.nextSibling);
    old.remove();
    this.recaptchaLoaded();
  };

  recaptchaError = e => {};

  loadRecaptchaScript() {
    this.setState({ loading: true });
    const uuid = Math.floor(Math.random() * 1000);
    window[`loadCallback${uuid}`] = this.recaptchaLoaded;
    const src = `https://www.recaptcha.net/recaptcha/api.js?onload=loadCallback${uuid}&render=explicit&hl=${this.props.locale}`;

    const head = document.getElementsByTagName("head")[0];
    const oldScript = document.getElementById("recaptcha-script");

    // If recaptcha has already been loaded, but the language has changed, we want to remove
    // the old script tag and replace it with a new one.
    // NOTE: you'll also need to remove the dom element that recaptcha has loaded into
    if (oldScript) {
      if (oldScript.src === src) {
        return;
      }
      head.removeChild(oldScript);
    }

    var script = document.createElement("script");
    script.src = src;
    script.type = "text/javascript";
    script.id = "recaptcha-script";

    head.appendChild(script);
  }

  render() {
    const { recaptchaError } = this.props;
    return (
      <RecaptchaContainer>
        <div
          className="g-recaptcha"
          id="g-recaptcha"
          data-expired-callback={this.recaptchaExpired}
          data-error-callback={this.recaptchaError}
        />
        {this.state.loading && <Spinner />}
        {recaptchaError && (
          <span role="alert" className="recaptcha-error">
            <Translation id="signin.recaptcha">beep boop</Translation>
          </span>
        )}
      </RecaptchaContainer>
    );
  }
}

Recaptcha.propTypes = {
  locale: PropTypes.string.isRequired
};

Recaptcha.defaultProps = {
  locale: "en"
};

export default Recaptcha;
